import React from "react";
import CartIcon from "./CartIcon";
import { usePFDataContext } from "../context/PfContext";
const ProductTableRow = ({ product,categoryName,brandName }) => {
    const { pfData } = usePFDataContext();
    return (
        <div
                                            key={product.id}
                                            className="product__list-row product__list-row--private"
                                            data-productid={product.id}
                                            data-strain={product.strain}
                                            data-thc={product.thc}
                                        >
                                            <div className="product__list-row--category">
                                                {categoryName}
                                                {
                                                    product.isNewProduct && parseInt(product.isNewProduct) === 1 && (
                                                        <span 
                                                            className="new-product"
                                                            style={{ color:"green", fontSize:"11px", lineHeight:"1", marginLeft:"15px" }}
                                                        >
                                                            New
                                                        </span>
                                                    )
                                                }
                                                {product.available && parseInt(product.available) <= 50 && (
                                                    <span className="low-stock" 
                                                     style={{ color:"red", fontSize:"11px", lineHeight:"1", marginLeft:"15px" }}
                                                    >
                                                        Low Stock
                                                    </span>
                                                )}
                                            </div>
                                           
                                            {pfData.pfView === "private" && ( 
                                                <>
                                                    <div className="product__list-row--available">{product.available}</div>
                                                    <div className="product__list-row--expiration-date">{product.batch_expiration_date}</div>
                                                    <div className="product__list-row--batch">{product.batch_code}</div>
                                                </>
                                            )}

                                            <div className="product__list-row--strain">{product.strain}</div>
                                            <div className="product__list-row--name">{product.sku_name}</div>
                                            <div className="product__list-row--weight">{product.weight}</div>
                                            <div className="product__list-row--thc">{product.thc_percentage}</div>
                                            <div className="product__list-row--case">{product.case_pack_size}</div>
                                            <div className="product__list-row--unit-price">{product.price_per_unit}</div>
                                            <div className="product__list-row--total-price">{Math.round(product.price_per_unit * product.case_pack_size * 100) / 100}</div>
                                            <div className="product__list-row--cart">

                                                    
                                                    <CartIcon 
                                                        id={product.id} 
                                                        name={product.sku_name} 
                                                        brand={brandName} 
                                                        price={product.price_per_unit} 
                                                     />
                                                
                                            </div>
                                        </div>
    );
}

export default ProductTableRow;